<div
  class="p-modal-payment-detail-panel__item"
  role="group"
  [attr.aria-label]="'slide ' + (itemNumber + 1) + ' of ' + lengthTraveler"
>
  <div class="p-modal-payment-detail-panel__head">
    <dl class="c-float-list04">
      <div class="c-float-list04__item c-float-list04__item--one">
        <!-- [1.9.22] 搭乗者姓名 -->
        <dt class="c-float-list04__title">
          <span class="c-float-list04__title-passenger">{{ passengerName | passengerName }}</span>
        </dt>
        <!-- /[1.9.22] 搭乗者姓名 -->
        <!-- [1.9.23] 搭乗者種別 -->
        <dd class="c-float-list04__contents c-float-list04__contents--left">
          {{ passengerType }}
        </dd>
        <!-- /[1.9.23] 搭乗者種別 -->
      </div>
    </dl>
  </div>
  <div class="p-modal-payment-detail-panel__body">
    <dl class="c-def-list02">
      <!-- [1.9.25] 運賃・フライトサーチャージ -->
      <div class="c-def-list02__item" *ngIf="isFaresOrFlightSurcharges">
        <dt class="c-def-list02__item-title" [innerHTML]="'label.fare' | staticMsg"></dt>
        <dd class="c-def-list02__item-body">
          <dl class="c-float-list04">
            <!-- [1.9.26] 運賃額 -->
            <div class="c-float-list04__item" *ngIf="showFaresAmount">
              <dt class="c-float-list04__title" [innerHTML]="'label.fare' | staticMsg"></dt>
              <dd class="c-float-list04__contents c-float-list04__contents--em">
                <ng-container *ngFor="let fare of faresAmount">
                  <div>
                    <span class="c-amount c-amount--price u-weight-bold">
                      <span class="c-amount__num">
                        {{ fare?.value ?? 0 | amountFormat : undefined : fare?.currencyCode }}
                      </span>
                    </span>
                  </div>
                </ng-container>
              </dd>
            </div>
            <!-- /[1.9.26] 運賃額 -->

            <!-- [1.9.45] 発券手数料、交換発行手数料 -->
            <div class="c-float-list04__item" *ngIf="isTicketingExchangeFee && !showTicketingFeeDiffCanada">
              <!-- [1.9.46] 税金名 -->
              <dt class="c-float-list04__title">
                {{ taxNameTicketingExchangeFee }}
              </dt>
              <!-- /[1.9.46] 税金名 -->
              <!-- [1.9.47] 税額 -->
              <dd class="c-float-list04__contents">
                <ng-container *ngFor="let ticketingFee of taxAmountTicketingExchangeFee">
                  <div>
                    <span class="c-amount c-amount--price">
                      <span class="c-amount__num">
                        {{ ticketingFee?.value ?? 0 | amountFormat : undefined : ticketingFee?.currencyCode }}
                      </span>
                    </span>
                  </div>
                </ng-container>
              </dd>
              <!-- /[1.9.47] 税額 -->
            </div>
            <!-- /[1.9.45] 発券手数料、交換発行手数料 -->
          </dl>
        </dd>
      </div>
      <!-- /[1.9.25] 運賃・フライトサーチャージ -->

      <!-- [1.9.24] 必要マイル数 -->
      <div class="c-def-list02__item c-def-list02__item--one" *ngIf="isRequiredNumberMiles">
        <dt class="c-def-list02__item-title" [innerHTML]="'label.requiredMileage' | staticMsg"></dt>
        <dd class="c-def-list02__item-body u-weight-bold">
          <span class="c-amount c-amount--price">
            <span class="c-amount__num" [innerHTML]="requiredNumberMiles | milesFormat : 'currencyUnit.MIL'"></span>
          </span>
        </dd>
      </div>
      <!-- /[1.9.24] 必要マイル数 -->

      <!-- [1.9.32] 税金・料金等詳細 -->
      <div class="c-def-list02__item" *ngIf="isTaxFeeDetails">
        <dt class="c-def-list02__item-title" [innerHTML]="'label.taxFare' | staticMsg"></dt>
        <dd class="c-def-list02__item-body">
          <!-- [1.9.33] 各国税額 -->
          <dl class="c-float-list04" *ngIf="isTaxAmountForEachCountry">
            <div class="c-float-list04__item" *ngFor="let tax of paymentInformations?.ticketPrices?.taxes">
              <!-- [1.9.34] 税金名 -->
              <dt class="c-float-list04__title">
                {{ taxNameForEachCountry(tax) }}
              </dt>
              <!-- /[1.9.34] 税金名 -->
              <!-- [1.9.35] 税額 -->
              <dd class="c-float-list04__contents">
                <span class="c-amount c-amount--price">
                  <span class="c-amount__num">
                    {{ taxAmountForEachCountry(tax) }}
                  </span>
                </span>
              </dd>
              <!-- /[1.9.35] 税額 -->
            </div>
            <!-- /[1.9.33] 各国税額 -->
          </dl>
        </dd>
      </div>
      <!-- /[1.9.32] 税金・料金等詳細 -->
    </dl>
  </div>
</div>
